<template>
    <div>
        <span class="text-overline grey--text" style="font-size: 10px;">{{ label }}</span>
        <div v-if="editing">
            <v-textarea
                v-if="multiline"
                v-model="draft"
                dense
                hide-details
                outlined
                autofocus
                rows="4"
                auto-grow
                class="caption mt-1"
                @keydown.esc="cancel"
            />
            <v-text-field
                v-else
                v-model="draft"
                dense
                hide-details
                outlined
                autofocus
                class="caption"
                @keydown.enter="save"
                @keydown.esc="cancel"
            />
            <div class="d-flex justify-end mt-2" style="gap: 8px;">
                <v-btn small outlined color="grey" @click="cancel">
                    <v-icon left small>mdi-close</v-icon> Cancel
                </v-btn>
                <v-btn small color="success" dark @click="save">
                    <v-icon left small>mdi-check</v-icon> Save
                </v-btn>
            </div>
        </div>
        <p v-else
            class="font-weight-medium text-body-2 mb-0 editable-value"
            :style="multiline ? 'white-space: pre-wrap;' : ''"
            @click="startEdit"
        >
            {{ value || '' }}
            <span v-if="!value" class="grey--text font-italic">{{ placeholder }}</span>
            <v-icon x-small class="edit-icon ml-1" color="grey lighten-1">mdi-pencil</v-icon>
        </p>
    </div>
</template>

<script>
export default {
    name: 'EditableField',
    props: {
        label: { type: String, required: true },
        value: { type: String, default: '' },
        placeholder: { type: String, default: 'Not set' },
        multiline: { type: Boolean, default: false },
    },
    data() {
        return {
            editing: false,
            draft: this.value,
        };
    },
    watch: {
        value(newVal) {
            this.draft = newVal;
        },
    },
    methods: {
        startEdit() {
            this.draft = this.value;
            this.editing = true;
        },
        save() {
            if (this.draft.trim() !== this.value) {
                this.$emit('save', this.draft.trim());
            }
            this.editing = false;
        },
        cancel() {
            this.draft = this.value;
            this.editing = false;
        },
    },
};
</script>

<style scoped>
.editable-value {
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
}
.editable-value:hover {
    background-color: rgba(0, 0, 0, 0.04);
}
.edit-icon {
    opacity: 0;
    transition: opacity 0.2s;
}
.editable-value:hover .edit-icon {
    opacity: 1;
}
</style>
